import { useRouter } from 'next/navigation'
import { ReactNode, Suspense } from 'react'

import ErrorBoundary from '../shared/error-boundary'
import ExitSurveyAlert from '../shared/exit-survey-alert'
import InstallBanner from '../shared/install-banner'
import ToastFallback from '../shared/toast-fallback'

import { TSession } from '@/libs/actions/auth/auth-actions.type'
import { useAppSelector } from '@/libs/hooks/use-app-selector'
import { usePreventExitSurvey } from '@/libs/hooks/use-prevent-exit-survey'
export default function MainNavbar({
  appLogo,
  rightElement,
  session,
}: Readonly<{ appLogo: ReactNode; rightElement?: ReactNode; session?: TSession | null }>) {
  const { push } = useRouter()
  const { checkPreventStatus, showPreventAlert, setShowPreventAlert, dismiss } =
    usePreventExitSurvey()

  const { partnerId } = useAppSelector((state) => state.user)
  const { suspend } = useAppSelector((state) => state.ui)

  const onClickLogo = () => {
    if (suspend) {
      return null
    }

    if (!!session || !partnerId) {
      return push('/')
    }

    if (partnerId) {
      return push('/auth/partner/home')
    }
  }

  return (
    <nav className={`sticky top-0 z-10 w-full bg-white`}>
      {!!session && (
        <Suspense>
          <ErrorBoundary fallback={<ToastFallback />}>
            <InstallBanner />
          </ErrorBoundary>
        </Suspense>
      )}
      <ExitSurveyAlert
        isOpen={showPreventAlert}
        onClose={() => setShowPreventAlert(false)}
        onSubmit={() => {
          dismiss()
          setShowPreventAlert(false)
          return onClickLogo()
        }}
      />
      <div className='flex h-[90px] w-full flex-1 flex-row items-center justify-between p-5 md:px-12 md:py-6 lg:mx-auto lg:px-16 xl:px-36'>
        <button
          type='button'
          tabIndex={0}
          onClick={() => {
            if (!checkPreventStatus()) {
              return onClickLogo()
            }
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              if (!checkPreventStatus()) {
                return onClickLogo()
              }
            }
          }}
        >
          {appLogo}
        </button>
        <div className='flex flex-row justify-end gap-4'>{rightElement}</div>
      </div>
    </nav>
  )
}
